import { graphql } from "../../graphql";

export const GridSettings = graphql(`
  fragment GridSettings on grid_settings {
    user_id
    adhoc_spreads_rows
    adhoc_spreads_switch
    alternating_row_colours
    broadcast_colour
    cal_current
    cal_switch
    cals
    enable_full_month_row_feature
    eod_colour
    extra_header_height
    flash_cell_updates
    global_colour
    grid_scratchpad_switch
    header_column_colour
    hide_broadcast
    hide_eod
    hide_global
    hide_private
    hide_status_row
    hlv_current
    hlv_switch
    hlvs
    hybrid_colour
    increment_map
    display_name_map
    indicator_colour
    listen_colour
    local_colour
    main_month_column_width
    months
    qtr_current
    qtr_switch
    qtrs
    quarter_borders
    scratchpad_max_cols
    scratchpad_max_rows
    season_current
    season_switch
    seasons
    sound
    status_map
    subheader_column_colour
    updated_at
    eod_date
    display_negative_bracket
    enabled_snapshot_warnings
    display_negative_color
    commodity_parent_group
    geographical_region
    commodity_group
    package
    description
    source
    field_name
    detailed_tooltip
    dont_show_remove_curve_confirmation_dialog
    dont_show_remove_multiple_curves_confirmation_dialog
    dont_show_clear_single_value_confirmation_dialog
    dont_show_clear_multiple_values_confirmation_dialog
	dont_show_anomaly_confirmation_dialog
    dont_show_paste_multiple_values_confirmation_dialog
    dont_show_drag_multiple_values_confirmation_dialog
    dont_show_remove_page_confirmation_dialog
    show_world_clock
    insert_page_position
    insert_column_position
    default_curve_column_width
    anomaly_sensitivity_level
    range_summary_dp
    range_summary_calc
    saved_colours
  }
`);

export const GridSettingsQuery = graphql(`
  query GridSettingsQuery($userId: String!) {
    grid_settings(where: { user_id: { _eq: $userId } }) {
      ...GridSettings
    }
  }
`);

export const GridSettingsSubscription = graphql(`
  subscription GridSettingsSubscription($userId: String!) {
    grid_settings(where: { user_id: { _eq: $userId } }) {
      ...GridSettings
    }
  }
`);

export const GridSettingsUpdate = graphql(`
  mutation GridSettingsUpdate(
    $userId: String!
    $values: grid_settings_set_input
  ) {
    update_grid_settings_by_pk(
      pk_columns: { user_id: $userId }
      _set: $values
    ) {
      user_id
    }
  }
`);

export const GridSettingsInsert = graphql(`
  mutation GridSettingsInsert($object: grid_settings_insert_input!) {
    insert_grid_settings_one(
      object: $object
      on_conflict: {
        constraint: grid_settings_pkey
        update_columns: [
          adhoc_spreads_rows
          adhoc_spreads_switch
          alternating_row_colours
          broadcast_colour
          cal_current
          cal_switch
          cals
          enable_full_month_row_feature
          eod_colour
          extra_header_height
          flash_cell_updates
          global_colour
          grid_scratchpad_switch
          header_column_colour
          hide_broadcast
          hide_eod
          hide_global
          hide_private
          hide_status_row
          hlv_current
          hlv_switch
          hlvs
          hybrid_colour
          increment_map
          display_name_map
          indicator_colour
          listen_colour
          local_colour
          main_month_column_width
          months
          qtr_current
          qtr_switch
          qtrs
          quarter_borders
          scratchpad_max_cols
          scratchpad_max_rows
          season_current
          season_switch
          seasons
          sound
          status_map
          subheader_column_colour
          updated_at
          eod_date
          enabled_snapshot_warnings
          commodity_parent_group
          geographical_region
          commodity_group
          package
          description
          source
          field_name
          detailed_tooltip
          dont_show_remove_curve_confirmation_dialog
          dont_show_remove_multiple_curves_confirmation_dialog
          dont_show_clear_single_value_confirmation_dialog
          dont_show_clear_multiple_values_confirmation_dialog
          dont_show_anomaly_confirmation_dialog
          dont_show_paste_multiple_values_confirmation_dialog
          dont_show_drag_multiple_values_confirmation_dialog
          dont_show_remove_page_confirmation_dialog
          show_world_clock
          insert_page_position
          insert_column_position
          default_curve_column_width
          anomaly_sensitivity_level
          range_summary_dp
          range_summary_calc
          display_negative_color
          display_negative_bracket
          saved_colours
        ]
      }
    ) {
      ...GridSettings
    }
  }
`);

/**
 * $from is inclusive - greater than or equal, to is exclusive - less than
 */
export const SnapshotDateQuery = graphql(`
  query SnapshotDateQuery($from: date!, $to: date!) {
    eod_entry(
      where: { evaluation_date: {
        _gte: $from
        _lt: $to
      } }
      order_by: { evaluation_date: desc }
      distinct_on: evaluation_date
      limit: 2
    ) {
      evaluation_date
    }
  }
`);
